<template>
    <div :class="stepProgressClass">
        <div :class="style.stepProgressBody" :style="`width: calc(${progress}% + 2px);`"></div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import style from './style.module.scss'

    export default Vue.extend({
        name: 'step-progress',
        components: {

        },
        props: {
            progress: Number,
            stepProgressCustomClass: null
        },
        computed: {
            stepProgressClass() {
                return this.stepProgressCustomClass || style.stepProgress
            }
        },
        data() {
            return {
                style: style
            }
        },
    })
</script>